import { IFlightTemplate } from "@vmosolutions/oc-interfaces";
import * as FlightBuilderActions from "../actions/FlightBuilder.Actions";

export interface IActiveTemplateNode {
  id: string;
  path: string[];
}

export interface IFlightBuilder {
  templates: IFlightTemplate[];
  isLoaded: boolean;
  activeNode: IFlightTemplate | null;
  copiedNode: IFlightTemplate | null;
  anchorEl: any;
  activeFileTemplate: IFlightTemplate | null;
  renameNodeId: string | null;
}

const defaultState: IFlightBuilder = {
  templates: [],
  isLoaded: false,
  activeNode: null,
  anchorEl: null,
  copiedNode: null,
  activeFileTemplate: null,
  renameNodeId: null,
};

/**
 * FlightBuilderReducer - Handles actions pertaining to the global state of the FlightBuilder window
 * @param state - - state for the FlightBuilderReducer with default values as defaultState shown above
 * @param action - - The actions defined in FlightBuilder.Actions. All the possible actions the reducer can handle
 */
export const FlightBuilderReducer = (
  state: IFlightBuilder = defaultState,
  action: FlightBuilderActions.Action
): IFlightBuilder => {
  switch (action.type) {
    case FlightBuilderActions.GOT_FLIGHT_BUILDER_TEMPLATES:
      return {
        ...state,
        templates: [...action.templates],
        isLoaded: true,
        activeFileTemplate: action.activeFileTemplate,
      };
    // case FlightBuilderActions.TOGGLE_IS_DIRECTORY_OPEN:
    //   return { ...state, directoriesOpen: { ...action.directoriesOpen } }
    // case FlightBuilderActions.INSERT_NEW_NODE:
    // case FlightBuilderActions.REMOVE_NODE:
    // case FlightBuilderActions.PASTE_NODE:
    //   return { ...state, templates: [...action.templates] }
    case FlightBuilderActions.SET_RENAME_NODE_ID:
      return { ...state, renameNodeId: action.renameNodeId };
    case FlightBuilderActions.SET_ACTIVE_NODE:
      // If user selects an activeNode (folder), set active file template to null.
      return { ...state, activeNode: action.activeNode, activeFileTemplate: null };
    case FlightBuilderActions.COPY_NODE:
      return { ...state, copiedNode: { ...action.node } };
    case FlightBuilderActions.SET_CONTEXT_ANCHOR:
      return { ...state, anchorEl: action.anchorEl };
    case FlightBuilderActions.SET_ACTIVE_FILE_TEMPLATE:
      return {
        ...state,
        activeFileTemplate: { ...action.activeFileTemplate },
        activeNode: { ...action.activeFileTemplate },
      };
    default:
      return state;
  }
};
